export default __webpack_public_path__ + "static/media/regulatory--axle-limit--g2.3974d220.png";